import React, { useState, useEffect } from "react";
import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import Icon from "../../components/AppIcon";

import AreasTable from "./components/AreasTable";
import GovernorateFormModal from "./components/GovernorateFormModal";
import AreaFormModal from "./components/AreaFormModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createAreaService,
  createGovernoratesService,
  deleteAreaService,
  deleteGovernoratesService,
  getAllgovernoratesService,
  updateAreaService,
  updateGovernoratesService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const GovernoratesAreasHierarchicalManagement = () => {
  const [language, setLanguage] = useState("en");

  const dispatch = useDispatch();

  const { governoratesList } = useSelector((state) => state.general);

  const [searchQuery, setSearchQuery] = useState("");
  const [isGovernorateFormOpen, setIsGovernorateFormOpen] = useState(false);
  const [isAreaFormOpen, setIsAreaFormOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedGovernorate, setSelectedGovernorate] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [formMode, setFormMode] = useState("add");
  const [deleteType, setDeleteType] = useState("governorate");
  const [expandedGovernorate, setExpandedGovernorate] = useState(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    setLanguage(savedLanguage);
  }, []);

  const labels = {
    title: {
      en: "Governorates & Areas Management",
      ar: "إدارة المحافظات والمناطق",
    },
    addGovernorate: { en: "Add Governorate", ar: "إضافة محافظة" },
    addArea: { en: "Add Area", ar: "إضافة منطقة" },
    search: { en: "Search...", ar: "بحث..." },
    noResults: { en: "No results found", ar: "لم يتم العثور على نتائج" },
    governoratesSection: { en: "Governorates", ar: "المحافظات" },
    areasSection: { en: "Areas", ar: "المناطق" },
  };

  useEffect(() => {
    dispatch(getAllgovernoratesService());
  }, []);

  const handleAddGovernorate = () => {
    setFormMode("add");
    setSelectedGovernorate(null);
    setIsGovernorateFormOpen(true);
  };

  const handleEditGovernorate = (governorate) => {
    setFormMode("edit");
    setSelectedGovernorate(governorate);
    setIsGovernorateFormOpen(true);
  };

  const handleDeleteGovernorate = (governorate) => {
    setDeleteType("governorate");
    setSelectedGovernorate(governorate);
    setIsDeleteModalOpen(true);
  };

  const handleAddArea = (governorate) => {
    setFormMode("add");
    setSelectedGovernorate(governorate);
    setSelectedArea(null);
    setIsAreaFormOpen(true);
  };

  const handleEditArea = (area, governorate) => {
    setFormMode("edit");
    setSelectedGovernorate(governorate);
    setSelectedArea(area);
    setIsAreaFormOpen(true);
  };

  const handleDeleteArea = (area, governorate) => {
    setDeleteType("area");
    setSelectedGovernorate(governorate);
    setSelectedArea(area);
    setIsDeleteModalOpen(true);

  };

  const handleSaveGovernorate = (governorateData) => {
    if (formMode === "add") {
      dispatch(createGovernoratesService(governorateData)).then((response) => {
        if (
          response.payload?.status === 200 ||
          response.payload?.status === 201
        ) {
          toast.success(
            language === "ar" ? "تم الإضافة بنجاح" : "Added successfully",
          );

          dispatch(getAllgovernoratesService({ page: 1 }));
          setIsGovernorateFormOpen(false);
        }
      });
    } else {
      dispatch(
        updateGovernoratesService({
          id: selectedGovernorate?.id,
          data: { ...governorateData },
        }),
      ).then((response) => {
        if (
          response.payload?.status === 200 ||
          response.payload?.status === 201
        ) {
          toast.success(
            language === "ar" ? "تم التعديل بنجاح" : "Added successfully",
          );

          dispatch(getAllgovernoratesService({ page: 1 }));
          setIsGovernorateFormOpen(false);
        }
      });
    }
  };

  const handleSaveArea = (areaData) => {
    console.log(areaData);
    if (formMode === "add") {
      const newArea = {
        ...areaData,
        id: Date.now(),
        governorateId: selectedGovernorate?.id,
        governorateName: selectedGovernorate?.name,
      };
      dispatch(
        createAreaService({
          governorate_id: selectedGovernorate?.id,
          ...areaData,
        }),
      ).then((response) => {
        if (
          response.payload?.status === 200 ||
          response.payload?.status === 201
        ) {
          toast.success(
            language === "ar" ? "تم الإضافة بنجاح" : "Added successfully",
          );

          dispatch(getAllgovernoratesService({ page: 1 }));
          setIsAreaFormOpen(false);
        }
      });
    } else {
      dispatch(
        updateAreaService({
          id: selectedArea?.id,
          data: {
            governorate_id: areaData?.governorateId,
            name: areaData?.name,
          },
        }),
      ).then((response) => {
        if (
          response.payload?.status === 200 ||
          response.payload?.status === 201
        ) {
          toast.success(
            language === "ar" ? "تم التعديل بنجاح" : "Added successfully",
          );

          dispatch(getAllgovernoratesService({ page: 1 }));
          setIsAreaFormOpen(false);
        }
      });
    }
  };

  const handleConfirmDelete = () => {
    if (deleteType === "governorate") {
      dispatch(deleteGovernoratesService(selectedGovernorate?.id)).then(
        (response) => {
          if (
            response.payload?.status === 200 ||
            response.payload?.status === 201 ||
            response.payload?.status === 204
          ) {
            toast.success("تم الحذف بنجاح");
            dispatch(getAllgovernoratesService({ page: 1 }));
            setIsDeleteModalOpen(false);
          }
        },
      );
    } else {
        dispatch(deleteAreaService(area?.id)).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201 ||
        response.payload?.status === 204
      ) {
        toast.success("تم الحذف بنجاح");
        dispatch(getAllgovernoratesService({ page: 1 }));
        setSelectedArea(area);
        setIsDeleteModalOpen(true);
      }
    });
    }
  };

  const getDeleteItemName = () => {
    if (deleteType === "governorate") {
      return selectedGovernorate?.name || "";
    }
    return selectedArea?.name || "";
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            {labels?.title?.[language]}
          </h1>
        </div>

        <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-6">
          <div className="flex flex-col md:flex-row gap-4 mb-6">
            <div className="flex-1">
              <Input
                placeholder={labels?.search?.[language]}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
              />
            </div>
            <div className="flex gap-3">
              <Button onClick={handleAddGovernorate} iconName="Plus">
                {labels?.addGovernorate?.[language]}
              </Button>
            </div>
          </div>

          {governoratesList?.length === 0 ? (
            <div className="text-center py-12">
              <Icon
                name="MapPin"
                size={48}
                className="mx-auto text-muted-foreground mb-4"
              />
              <p className="text-lg text-text-secondary">
                {labels?.noResults?.[language]}
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              {governoratesList?.map((governorate) => (
                <div
                  key={governorate?.id}
                  className="border border-border rounded-lg overflow-hidden"
                >
                  <div className="bg-muted/50 p-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() =>
                          setExpandedGovernorate(
                            expandedGovernorate === governorate?.id
                              ? null
                              : governorate?.id,
                          )
                        }
                        className="p-2 hover:bg-muted rounded-lg transition-smooth"
                      >
                        <Icon
                          name={
                            expandedGovernorate === governorate?.id
                              ? "ChevronDown"
                              : "ChevronRight"
                          }
                          size={20}
                        />
                      </button>
                      <div>
                        <h3 className="text-lg font-semibold text-foreground">
                          {governorate?.name}
                        </h3>
                        <p className="text-sm text-text-secondary">
                          {governorate?.areas?.length || 0}{" "}
                          {language === "en" ? "areas" : "منطقة"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleAddArea(governorate)}
                        iconName="Plus"
                      >
                        {labels?.addArea?.[language]}
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleEditGovernorate(governorate)}
                        className="h-8 w-8"
                      >
                        <Icon name="Edit" size={16} />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDeleteGovernorate(governorate)}
                        className="h-8 w-8 text-error hover:text-error"
                      >
                        <Icon name="Trash2" size={16} />
                      </Button>
                    </div>
                  </div>

                  {expandedGovernorate === governorate?.id &&
                    governorate?.areas?.length > 0 && (
                      <div className="p-4">
                        <AreasTable
                          areas={governorate?.areas}
                          governorate={governorate}
                          language={language}
                          onEdit={handleEditArea}
                          onDelete={handleDeleteArea}
                        />
                      </div>
                    )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <GovernorateFormModal
        isOpen={isGovernorateFormOpen}
        onClose={() => setIsGovernorateFormOpen(false)}
        onSave={handleSaveGovernorate}
        governorate={selectedGovernorate}
        mode={formMode}
        language={language}
      />

      <AreaFormModal
        isOpen={isAreaFormOpen}
        onClose={() => setIsAreaFormOpen(false)}
        onSave={handleSaveArea}
        area={selectedArea}
        governorate={selectedGovernorate}
        governorates={governoratesList}
        mode={formMode}
        language={language}
      />

      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        itemName={getDeleteItemName()}
        language={language}
      />
    </div>
  );
};

export default GovernoratesAreasHierarchicalManagement;
